export default __webpack_public_path__ + "static/media/745.b6a29abe.png";